import Dropdown from 'assets/images/dropdownicon.svg';
import React, { useState } from 'react';
import { rotateIcon, toggleDropdown } from './ClassUtils';

interface Props {
  placeholder: string;
  buttonDesign?: string;
  arrowIconSize?: string;
  buttonSize?: 'sm' | 'lg' | 'xm';
  optionsList: Array<string>;
  optionsDesign?: string;
  optionsHolderDesign?: string;
}

export const ElrButtonDropdown: React.FC<
  Props & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({
  placeholder,
  buttonDesign,
  arrowIconSize = 'w-4 h-4',
  buttonSize = 'lg',
  optionsList,
  optionsDesign,
  optionsHolderDesign,
  ...props
}) => {
  const sizes = {
    lg: 'min-w-16 min-h-1',
    sm: 'min-w-16 min-h-1',
    xm: 'min-w-16 min-h-full',
  };

  const [isDropOpen, setIsDropOpen] = useState(false);
  const [nameDisplayed, setNameDisplayed] = useState(placeholder);

  const handleClick = (name?: string) => {
    if (name) {
      setNameDisplayed(name);
    }
    setIsDropOpen((prevstate) => !prevstate);
  };

  return (
    <div className="flex justify-center">
      <button
        {...props}
        type="button"
        className={`${buttonDesign} ${sizes[buttonSize]} bg-white text-elr-gray-400 flex items-center justify-between px-4 py-2 rounded-md focus:outline-none`}
        onClick={() => handleClick()}
      >
        {nameDisplayed}
        <img
          src={Dropdown}
          className={`${arrowIconSize} ${rotateIcon(isDropOpen)} ml-auto`}
          alt="dropdown button"
        />
      </button>

      <div
        className={`${toggleDropdown(
          isDropOpen
        )} ${optionsHolderDesign} text-elr-gray absolute rounded-5 bg-elr-black w-24 mt-8`}
      >
        {optionsList.map((item) => (
          <div
            className={`hover:cursor-pointer hover:opacity-70 ${optionsDesign} text-12 pb-2.5 first:pt-2.5 pl-3`}
            onClick={() => handleClick(item)}
            key={item}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};
